import styled  from "styled-components";

export const Errors = styled.div`
  background: white;
  position: absolute;
  right: 1em;
  left: 1em;
  top: -20%;
  bottom: 1em;
  z-index: 4;

  &.hide {
    display: none;
  }

  h1 {
    text-align: center;
    color: orangered;
  }

  .error {
    color: orangered;
  }
`;
export const Ul = styled.div`
  list-style: none;
`;
export const Li = styled.div`
  padding: 1em;
  font-size: 1.05em;
`;
